/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { pinchZoomManager } from "../pinchZoom";
import { pageContentHandler } from "pageContentHandler";
import { isZoomFeatureEnabled } from "selectors/appSelectors";

class TouchManager {
  handleTouchStart(event, stores) {
    stores.touchSelStore.hideContextMenu(true);
    isZoomFeatureEnabled(stores) && pinchZoomManager.handleTouchStart(event, stores);
  }

  handleTouchEnd(event, stores) {
    stores.touchSelStore.showContextMenuDebounced();
    isZoomFeatureEnabled(stores) && pinchZoomManager.handleTouchEnd(event, stores);
  }

  handleTouchCancel(event, stores) {
    isZoomFeatureEnabled(stores) && pinchZoomManager.handleTouchCancel(event, stores);
  }

  handleTouchMove(event, stores) {
    isZoomFeatureEnabled(stores) && pinchZoomManager.handleTouchMove(event, stores);
  }

  disableTouchEvent(event) {
    event.cancelable !== false && event.preventDefault();
  }
}

export const touchManager = new TouchManager();
